import { LoadingSkeleton } from '@bloomfieldrobotics/canopy';
import { useField } from 'formik';
import { useGetVarietyQuery } from '../../../../services/entities/impl/blfApi/endpoints/varieties';
import { FormFieldProps } from '../generic/crud/components/GenericFormField';

/**
 * This component is used to display the name of a variety in a form.
 */
export const VarietyFormDisplay = (props: FormFieldProps) => {
  const [field] = useField(props);
  const {
    data: variety,
    isLoading,
    isFetching,
  } = useGetVarietyQuery(field.value, {
    skip: !field.value,
  });

  const displayLabel = variety ? `${variety.name} (${variety.cropType})` : '';

  return (
    <LoadingSkeleton loading={isLoading || isFetching} width='100%'>
      {displayLabel}
    </LoadingSkeleton>
  );
};
